module.exports = __webpack_public_path__ + "img/main_05_product_img_03.5ae08bfc.png";